<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name {{ keyName }}
      span.validation-label(v-if="required == true") 必須

    .register-value
      .d-flex.justify-content-center
        input.register-form.datetime.mr-1(v-model="_value" :name="name" type="text" :placeholder="placeholder"
          v-validate="validationRules" :data-vv-as="(validationKeyName) ? validationKeyName : keyName" @click="showModal" readonly
        )
        b-button.clear-btn(@click="ondelete")
          span クリア

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br

  TimePickerModal(v-model="show" :time.sync="_time" :minutes-step="minutesStep" @ok="inputTime")
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import TimePickerModal from "@/pc/basics/TimePickerModal.vue";

/**
 * ### 時間入力コンポーネント
 *
 * - タイムピッカーでの日付入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component({
  components: {
    TimePickerModal
  }
})
export default class FormTimePicker extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 時刻 */
  @Prop({ required: true })
  time!: string;
  /** 時間の上昇値 */
  @Prop({ default: () => 5 })
  minutesStep!: number;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** input要素のプレースホルダー */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  placeholder!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  show: boolean = false;

  public showModal(): void {
    this.show = true;
    return;
  }

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    if (this.value) {
      const deisplayTime: string[] = this.value.split(":");
      return deisplayTime[0] + "：" + deisplayTime[1];
    } else {
      return "";
    }
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    return;
  }

  public inputTime(): void {
    this.$emit("input", this.time);

    return;
  }

  get _time(): string {
    return this.time;
  }

  set _time(newValue: string) {
    this.$emit("update:time", newValue);
    return;
  }

  public ondelete(): void {
    this.$emit("input", null);
    return;
  }
}
</script>

<style lang="scss" scoped>
.register-form {
  min-width: 124px !important;
  width: 124px !important;
}
</style>
